import { useState, useEffect,useContext, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import folder from "../../folder.svg"; // Import the folder image
import "../../styles/AdminHome.css"; // Import the CSS file for styling
import axios from 'axios';
import jsPDF from "jspdf";
import BASE_URL from '../../BaseUrl';
import { GlobalContext } from '../GlobalContext';

export default function AdminHome({active,setActive, setMobileActive}) {
    const {admin, setAdmin} = useContext(GlobalContext);
    const navigate = useNavigate();
    const [loaded, setLoaded] = useState(false);
    const [reload, setReload] = useState(false);
    const [message, setMessage] = useState("error message");
    const [showMessage, setShowMessage] = useState(false);
    const [showDeleteCourseForm,setShowDeleteCourseForm] = useState(false);
    const [introLessons, setIntroLessons] = useState([]);
    const [getCodes, setGetCodes] = useState(false);
    const [capacityExceeded, setCapacityExceeded] = useState(false);
    const [showWarning, setShowWarning] = useState(false);
    const [showNewLessonForm, setShowNewLessonForm] = useState(false);
    const [lessonToEdit, setLessonToEdit] = useState({});
    const warning = 'هذا الحقل مطلوب';
    const [showQRPopup, setShowQRPopup] = useState(false);
    const [showAddNewCourseForm, setShowAddNewCourseForm] = useState(false);
    const [showDeleteLessonForm, setShowDeleteLessonForm] = useState(false);
    const [showEditLessonFrom,setShowEditLessonFrom] = useState(false)
    const [codesToGenerate,setCodesToGenerate] = useState(0);
    const [newCourse, setNewCourse] = useState({
        courseId:"",
        name:"",
        term:"",
        year:"",
        category:"",
        number: 0,
    });
    const [courseToEdit, setCourseToEdit] = useState({
                                            name:"",
                                            courseId:"",
                                            term:"",
                                            year:"",
                                            category:""
                                        });

    const [newLesson,setNewLesson] = useState({
        lessonId:"",
        lessonName:"",
        teacherId: admin? admin.id:"",
        date: null,
        url:"",
        imageUrl:""
    })
    const [showEditCourseForm, setShowEditCourseForm] = useState(false);
    const category = ["عربي","انجليزي","رياضيات","فيزياء","كيمياء","أحياء","تاريخ","جغرافيا","فلسفة","علم نفس","دين","فرنساوي","الماني","ايطالي","اسباني","جيولوجيا","علوم","دراسات","تأسيسي","أخرى"];
    const termsArabic = ["الفصل الدراسي الاول", "الفصل الدراسي الثاني"];
    const yearsArabic = ["الصف الاول الابتدائي","الصف الثاني الابتدائي","الصف الثالث الابتدائي","الصف الرابع الابتدائي","الصف الخامس الابتدائي","الصف السادس الابتدائي","الصف الاول الاعدادي","الصف الثاني الاعدادي","الصف الثالث الاعدادي","الصف الاول الثانوي","الصف الثاني الثانوي","الصف الثالث الثانوي"];
    const suggestedNotificationTitles = ["ملاحظة هامة","امتحان","تذكير","بداية الحصص","إلغاء حصة","تغيير موعد الحصة"];
    const arabicNumbers = {
        الاول: "١",
        الثاني: "٢",
        الثالث: "٣",
        الرابع: "٤",
        الخامس: "٥",
        السادس: "٦"
    };


    const [showNotifyPopup, setShowNotifyPopup] = useState(false);
    const [notifyTitle, setNotifyTitle] = useState("");
    const [notifyMessage, setNotifyMessage] = useState("");
    const [notifyYear, setNotifyYear] = useState("");
    const [sendingNotification, setSendingNotification] = useState(false);

    const shortTerm = (term)=>{
        if(term === "تأسيسي" || term === "أخرى" || term === "الصف الثالث الثانوي"){
            return "";
        }
        return 'ت'+arabicNumbers[term.split(" ")[2]];
    }
    const levelMap = {
        الابتدائي: "ب",
        الاعدادي: "ع",
        الثانوي: "ث"
    };

    const shortYears =(year) => {
        if(year === "تأسيسي" || year === "أخرى"){
            return year;
        }
        const parts = year.split(" ");
        const numberWord = parts[1];       
        const levelWord = parts[2];        

        return arabicNumbers[numberWord] + levelMap[levelWord];
    };
    const changeStyle = (id)=>{
            const el = document.getElementById(id);
            el.style.borderColor = "black";
            el.style.color = "black";
    }

    const sendTeacherNotification = async () => {
            if (!notifyTitle.trim() || !notifyMessage.trim() || !notifyYear) {
                alert("يرجى إدخال عنوان الرسالة ومحتواها واختيار الصف الدراسي");
                return;
            }

            setSendingNotification(true);

            try {
                const response = await axios.post(
                    `${BASE_URL}/teacher/notify-students`,
                    {
                        title: notifyTitle.trim(),
                        message: notifyMessage.trim(),
                        year: notifyYear === "all" ? "" : notifyYear,
                        fileExtension: admin.imageExt
                    },
                    {
                        withCredentials: true
                    }
                );

                setShowNotifyPopup(false);
                setMessage(response.data);
                setShowMessage(true);

                setNotifyTitle("");
                setNotifyMessage("");
                setNotifyYear("");

            } catch (error) {
                console.error("Error sending notification:", error);

                setMessage(
                    error.response?.data ||
                    "حدث خطأ أثناء إرسال الرسالة"
                );
                setShowNotifyPopup(false);
                setShowMessage(true);
            } finally {
                setSendingNotification(false);
            }
    };

    async function getListOfCodes(){
        setGetCodes(true);
        const respons = await axios.get(`${BASE_URL}/teacher/code?lessonId=${courseToEdit.courseId}&number=${codesToGenerate}&isQR=1`,{withCredentials:true});
        setGetCodes(false);
        return respons.data;
  }

    function deleteCourse(){
        axios.delete(`${BASE_URL}/teacher/course?adminId=${admin.id}&courseId=${courseToEdit.courseId}`,{withCredentials:true})
        .then((response)=>{
            setMessage(response.data);
            setShowDeleteCourseForm(false);
            setShowMessage(true);
            setReload(!reload);

        }).catch((error)=>{
            console.log(error);
        })
    }
    const sendNewCourse = ()=>{
        if(newCourse.year === ""){
            const el = document.getElementById("year");
            el.style.borderColor = "red";
            el.style.color = "red";
            return;
        }
        if(newCourse.term === ""){
            const el = document.getElementById("term");
            el.style.borderColor = "red";
            el.style.color = "red";
            return;
        }
        if(newCourse.category === ""){
            const el = document.getElementById("category");
            el.style.borderColor = "red";
            el.style.color = "red";
            return;
        }
        if(newCourse.name === ""){
            const el = document.getElementById("course-name");
            el.style.borderColor = "red";
            el.style.color = "red";
            return;
        }

        axios.post(`${BASE_URL}/teacher/new-course`,newCourse,{withCredentials: true})
        .then((response)=>{
            setMessage(response.data);
            setShowMessage(true);
            setShowAddNewCourseForm(false);
            setNewCourse({
                    courseId:"",
                    name:"",
                    term:"",
                    year:"",
                    category:""
                })
            setReload(!reload);
        }).catch((error)=>{
            console.log(error);
        })
    }


    const updateCourse = ()=>{
        if(courseToEdit === null || courseToEdit === undefined){
            return;
        }
        axios.put(`${BASE_URL}/teacher/update-course`,courseToEdit,{withCredentials:true})
        .then((response)=>{
            setMessage(response.data);
            setShowMessage(true);
            setShowEditCourseForm(false);
            setReload(!reload);
        }).catch((error)=>{
            console.log(error);
        })
    }

    function deleteLesson(){
        axios.delete(`${BASE_URL}/teacher/delete-intro-lesson?lessonId=${lessonToEdit.lessonId}`, {withCredentials: true})
            .then((response)=>{
                setShowDeleteLessonForm(false);
                setMessage("تم حذف الدرس التعريفي بنجاح");
                setShowMessage(true);
                setReload(!reload);
            }).catch((error)=>{
                console.log(error);
                setShowDeleteLessonForm(false);
            })
      }
    
      const updateLesson = ()=>{
    
              axios.put(`${BASE_URL}/teacher/update-intro-lesson`,{...lessonToEdit},{withCredentials: true})
              .then((response)=>{
                  setLessonToEdit({})
                  setShowEditLessonFrom(false);
                  setReload(!reload);
              }).catch((error)=>{
                  console.log(error);
              })
          }

    async function checkSize(){
        try{
            await axios.get(`${BASE_URL}/teacher/check-new-lesson`,{withCredentials: true});
            return true;
        }catch (error){
            if(error.response.status === 406){
                    setCapacityExceeded(true);
                }
                else{
                    console.log(error);
                    navigate("/");
                }
                setShowNewLessonForm(false);
                return false;
        }
        
        
    }

    async function downloadCodes (){
        const doc = new jsPDF();
        if(codesToGenerate <= 0) return;
        setGetCodes(true);
        try{
          const respons = await axios.get(`${BASE_URL}/teacher/code?lessonId=${courseToEdit.courseId}&number=${codesToGenerate}&isQR=0`,{withCredentials:true});
          // doc.text(respons.data.join("\n"),10,10);
          const margin = 10;
          const pageHeight = doc.internal.pageSize.height;
          const lineHeight = 7;
    
          let y = margin;
    
          respons.data.forEach(item => {
            if (y + lineHeight > pageHeight - margin) {
              doc.addPage();
              y = margin;
            }
    
            doc.text(item, margin, y);
            y += lineHeight;
          });
    
          doc.save(`${courseToEdit.name}.pdf`);
          setGetCodes(false);
          setShowQRPopup(false);
        } catch(error){
          if(error.response.status === 401){
            setCapacityExceeded(true);
            setGetCodes(false);
            setShowQRPopup(false);
          }
        }
      }

    const addNewLesson = async()=>{
        const isExceede = await checkSize();
        if(!isExceede){
            setNewLesson({...newLesson, lessonName:"",price:0,url:"",imageUrl:""});
            return;
        }
        if(newLesson.lessonName === "" || newLesson.url === ""){
            setShowWarning(true);
            return;
        }
        axios.post(`${BASE_URL}/teacher/new-intro-lesson?`,newLesson,{withCredentials:true})
            .then(()=>{
                setNewLesson({...newLesson, lessonName:"",price:0,url:"",imageUrl:""});
                setShowNewLessonForm(false);
                setMessage("تم اضافة الدرس التعريفي بنجاح");
                setShowMessage(true);
                setReload(!reload);
            }).catch((error)=>{
                console.log(error);
                navigate("/");
            })
        
    }

    const changeUrl = (value)=>{
        const splits = value.split('.be/')[1];
        if(splits === null || splits === undefined){
            return;
        }
        const videoId = splits.split("?")[0];
        setNewLesson({...newLesson,imageUrl:`https://img.youtube.com/vi/${videoId}/hqdefault.jpg`,url:`https://www.youtube.com/embed/${videoId}`});
    }
// eslint-disable-next-line react-hooks/exhaustive-deps
    const fetchData = async()=>{
    
    var admin2 = null;
    if(admin === null || admin === undefined){
        await axios.get(`${BASE_URL}/teacher/get-admin-by-token`,{withCredentials:true})
        .then((response)=>{
            setAdmin(response.data);
            admin2 = response.data;
        }).catch((error)=>{
            navigate("/")
        })
    }
    else{
        admin2 = {...admin};
    }
    axios.get(`${BASE_URL}/teacher/courses?adminId=${admin2.id}`, { withCredentials: true })
        .then((response) => {
            // const updateAdmin = { ...admin, courses: response.data };
            setAdmin({ ...admin, courses: response.data });
            setLoaded(true);
            
        }).catch((error) => {
            console.error("Error fetching course data:", error);
            navigate("/");
        })
    axios.get(`${BASE_URL}/teacher/my-intro-lessons`, { withCredentials: true })
        .then((response) => {
            setIntroLessons(response.data);
        }).catch((error) => {
            console.error("Error fetching introductory lessons:", error);
        });

    axios.get(`${BASE_URL}/teacher/message?adminId=${admin2.id}`, { withCredentials: true })
    .then((response) => {
        if(response.data !== null && response.data !== undefined && response.data !== ""){
            setMessage(response.data);
            setShowMessage(true);
        }
    }).catch((error) => {
        console.error("Error fetching message:", error);
    })
   }


   useEffect( () => {  
    setActive("المواد الدراسية");
    setMobileActive("courses mobile");
    fetchData();
},[reload]);
    
    return(
        <div>
                   
            {loaded &&(    
                <div className='admin-home-container'>
                    
                    <div style={{paddingBottom:"50px"}}><h3>المواد الدراسية </h3>
                    <button className='add-new-course' onClick={()=>setShowAddNewCourseForm(true)}>اضافةمادة</button>
                    <button
                        type="button"
                        onClick={() => setShowNotifyPopup(true)}
                        className= "send-notification-button">
                        إرسال رسالة للطلاب
                    </button>
                    {admin.courses.map((course)=>(
                    <div className={`course-card-animation ${active==="المواد الدراسية" ? "course-card-in" : "course-card-out"}`}>
                        <div className='course-card' onClick={() => {navigate(`/admin-home/folder/${course.courseId}`);}}>
                            <div className="course-card-buttons">
                                    <button className='delete-course-button' onClick={(e)=>{e.stopPropagation();setCourseToEdit({...courseToEdit, courseId: course.courseId, name : course.name});setShowDeleteCourseForm(true)}}>حذف</button>
                                    <button className='edit-course' onClick={(e)=>{
                                        e.stopPropagation();
                                        setCourseToEdit(course);
                                        setShowEditCourseForm(true);
                                    }}>تعديل</button>
                                    <button className='get-qr-codes' onClick={(e)=>{
                                        e.stopPropagation();
                                        setCourseToEdit(course);
                                        setShowQRPopup(true);
                                    }}>أكواد</button>
                            </div>
                            <div style={{width:"35%",display:"block", textAlign:"right",lineBreak:"auto", paddingTop:"15px"}}>
                                <h4 style={{width:"100%", textAlign:"right",lineBreak:"auto", height:"80%" , marginBottom:"0%"}}>{course.name}</h4>
                                <div style={{display:"flex", justifyContent:"right"}}>
                                    <p style={{height:"20%", fontSize:"smaller", marginBottom:"0%", fontWeight:"bold"}}>{shortTerm(course.term)}</p>
                                    <p style={{height:"20%", fontSize:"smaller", marginBottom:"0%", fontWeight:"bold"}}>{shortYears(course.year)}</p>
                                </div>
                            </div>
                            <img src={folder} alt='no' className='course-photo'></img>
                            
                        </div>
                    </div>
                    ))}
                    </div>
                    <div className='introductory-lessons'>
                        <h3>حصص تعريفية بك</h3>
                        <button className='add-new-course' onClick={()=>setShowNewLessonForm(true)}>اضافة درس</button>
                        {introLessons.map((lesson)=>{
                            return(
                                <div className="lesson-card" onClick={()=>{navigate(`/admin-home/intro-lesson/${lesson.lessonId}`)}}>
                                    <div className="lesson-card-buttons">
                                        <button className="delete-lesson-button"
                                    onClick={(e)=>{
                                        e.stopPropagation();
                                        setLessonToEdit({...lesson});
                                        setShowDeleteLessonForm(true);
                                    }}
                                    >حذف</button>
                                    <button className="update-unit-button" onClick={(e)=>{
                                        e.stopPropagation();
                                        setLessonToEdit({...lesson});
                                        setShowEditLessonFrom(true);
                                    }}>تعديل</button>
                                    </div>
                                    <h5>{lesson.lessonName}</h5>
                                    <img className="lesson-image" src={lesson.imageUrl} alt="no"></img>
                                    
                                </div>
                            )
                        })}
                        <p>هذه الدروس تكون مجانية للجميع بحيث يتعرف الطالب علي اسلوبك من خلالها</p>
                    </div>
            
            </div>)}

            {showEditCourseForm&&(
                <div className="overlay">
                <div className='add-new-course-form'>
                    <h2>تعديل المادة</h2>
                    <label>اسم المادة</label>
                    <input id='course-name' 
                        dir="rtl"
                        lang="ar"
                        type="text" 
                        value={courseToEdit.name}
                        onChange={(e)=>{setCourseToEdit({...courseToEdit, name:e.target.value});
                    changeStyle(e.target.id);
                }} />
                    <div className='year-term-selection'>
                    <select 
                    value={courseToEdit.year} 
                    id="year" 
                    disabled={courseToEdit.category === "تأسيسي" || courseToEdit.category === "أخرى"}
                    onChange={(e)=>{setCourseToEdit({...courseToEdit, year:e.target.value});
                    changeStyle(e.target.id);
                }}>
                        <option value={""}>--- الصف ---</option>
                        {yearsArabic.map((year,index)=>(
                            <option value={yearsArabic[index]} >{year}</option>
                        ))}
                    </select>
                    <select 
                    value={courseToEdit.term} 
                    id="term" 
                    disabled={courseToEdit.category === "تأسيسي" || courseToEdit.category === "أخرى"}
                    onChange={(e)=>{setCourseToEdit({...courseToEdit, term:e.target.value});
                    changeStyle(e.target.id);
                }}>
                        <option value={""}>---الفصل الدراسي---</option>
                        {termsArabic.map((term,index)=>(
                            <option value={termsArabic[index]}>{term}</option>
                        ))}
                    </select>
                    <select
                        id="category"
                        value={courseToEdit.category}
                        onChange={(e) => {
                            if(e.target.value === "تأسيسي" || e.target.value === "أخرى"){
                                setCourseToEdit({...courseToEdit, year:e.target.value, term:e.target.value, number: 0, category:e.target.value});
                                var yearEl = document.getElementById("year");
                                var termEl = document.getElementById("term");
                                yearEl.value = "";
                                termEl.value = "";
                                yearEl.style = {};
                                termEl.style = {};
                            }else setCourseToEdit({...courseToEdit, category:e.target.value});
                            changeStyle(e.target.id);
                    }}
                    >
                        <option value="">--التصنيف--</option>
                        {category.map((subj, index) => (
                        <option value={category[index]}>
                            {subj}
                        </option>
                        ))}
                    </select>
                    </div>
                    <div className='new-course-form-buttons'>
                        <button onClick={()=>{
                            setCourseToEdit({
                                            name:"",
                                            courseId:"",
                                            term:"",
                                            year:"",
                                            category:""
                                        });
                                        setShowEditCourseForm(false);
                        }}>إلغاء</button>
                        <button onClick={updateCourse} >تعديل</button>
                    </div>
                </div>
                </div>
            )}

            {showAddNewCourseForm&&(
                <div className="overlay">
                <div className='add-new-course-form'>
                    <h2>مادة جديدة</h2>
                    <label>اسم المادة</label>
                    <input id='course-name' 
                        dir="rtl"
                        lang="ar" 
                        type="text" 
                        value={newCourse.name} 
                        onChange={(e)=>{setNewCourse({...newCourse, name:e.target.value});
                    changeStyle(e.target.id);
                }} />
                    <div className='year-term-selection'>
                    <select id="year"
                    disabled={newCourse.category === "تأسيسي" || newCourse.category === "أخرى"}
                    onChange={(e)=>{
                        // setNewCourse({...newCourse, year:e.target.value});
                        console.log(e.target.value);
                        changeStyle(e.target.id);
                        var num = 0;
                        if(e.target.value !== "" && newCourse.term !== ""){
                            num = ((yearsArabic.indexOf(e.target.value) + 1) * 2) - 1;
                            num += termsArabic.indexOf(newCourse.term);
                            setNewCourse({...newCourse, number: num ,year:e.target.value});
                        } 
                        if(e.target.value === "الصف الثالث الثانوي"){
                            console.log("in 2 th");
                            num = 23;
                            setNewCourse({...newCourse, number: num ,year:e.target.value, term:e.target.value});
                            console.log("term is modified");
                            document.getElementById("term").value = "";
                            document.getElementById("term").style = {color:"gray"};
                        }else{
                            setNewCourse({...newCourse, number: num ,year:e.target.value});
                        }
                }}>
                        <option value={""}>--- الصف ---</option>
                        {yearsArabic.map((year,index)=>(
                            <option value={yearsArabic[index]} >{year}</option>
                        ))}
                    </select>
                    <select id="term" 
                        disabled={newCourse.category === "تأسيسي" || newCourse.category === "أخرى" || newCourse.year === "الصف الثالث الثانوي"}
                        onChange={(e)=>{
                        // setNewCourse({...newCourse, term:e.target.value});
                        changeStyle(e.target.id);
                        var num = 0;
                        if(e.target.value !== "" && newCourse.year !== ""){
                            num = ((yearsArabic.indexOf(newCourse.year) + 1) * 2) - 1;
                            num += termsArabic.indexOf(e.target.value);
                        }
                        setNewCourse({...newCourse, number: num, term:e.target.value});
                }}>
                        <option value={""}>---الفصل الدراسي---</option>
                        {termsArabic.map((term,index)=>(
                            <option value={termsArabic[index]}>{term}</option>
                        ))}
                    </select>
                    <select
                        id="category"
                        onChange={(e) => {
                        changeStyle(e.target.id);
                        if(e.target.value === "تأسيسي" || e.target.value === "أخرى"){
                            var yearEl = document.getElementById("year");
                            var termEl = document.getElementById("term");
                            yearEl.value = "";
                            termEl.value = "";
                            yearEl.style = {};
                            termEl.style = {};
                            setNewCourse({...newCourse, year:e.target.value, term:e.target.value, number: 0, category:e.target.value});
                            
                        }else{
                            setNewCourse({...newCourse, category:e.target.value});
                        }
                        
                    }}
                    >
                        <option value="">--التصنيف--</option>
                        {category.map((subj, index) => (
                        <option value={category[index]}>
                            {subj}
                        </option>
                        ))}
                    </select>
                    </div>
                    <div className='new-course-form-buttons'>
                        <button onClick={()=>{
                            setNewCourse({
                                            name:"",
                                            courseId:"",
                                            term:"",
                                            year:"",
                                            category:""
                                        });
                                        setShowAddNewCourseForm(false);
                        }}>إلغاء</button>
                        <button onClick={sendNewCourse}>اضافة المادة</button>
                    </div>
                </div>
                </div>
            )}
            { showMessage && (
                <div className="overlay">
                <div className="home-owner-message">
                    <p>{message}</p>
                    <button onClick={() => setShowMessage(false)}>اغلاق</button>
                </div>
                </div>
            )}
            {showDeleteCourseForm &&(
                    <div className="overlay">
                    <div className="delete-course-form">
                        
                        <div>
                            <h3>حذف المادة</h3>
                            <p>هل انت متأكد أنك تريد حذف هذه المادة؟</p>
                            <p>{courseToEdit.name}</p>
                        </div>
                        <div style={{display:"flex" ,width:"100%", justifyContent:"space-between", padding:"10px"}}>
                            <button  onClick={deleteCourse}>نعم</button>
                            <button onClick={()=>setShowDeleteCourseForm(false)}>لا</button>
                        </div>
                        </div>
                    </div>

                )}

                {showNewLessonForm&&(
                    <div className="overlay">
                    <div className="add-new-lesson-form">
                        <h3>درس تعريفي جديد</h3>
                        <label>عنوان الدرس</label>
                        <input type="text" 
                        dir="rtl"
                        lang="ar"
                        value={newLesson.lessonName}
                        className={(showWarning && newLesson.lessonName === "")?"wrong-field": ""}
                        onChange={(e)=>{setNewLesson({...newLesson, lessonName: e.target.value});setShowWarning(false);}}/>
                        {showWarning && (<p className="warning">{warning}</p>)}
                        {capacityExceeded && (
                            <p className="capacity-exceeded">سعة التخزين لا تكفي برجاء الترقية لاضافة المزيد من الدروس</p>
                        )}
                        <label>رابط الدرس من اليوتيوب</label>
                        <input type="text"
                        className={(showWarning && newLesson.url === "")?"wrong-field": ""}
                        onChange={e=>{changeUrl(e.target.value);setShowWarning(false);}}
                        ></input>
                        <button className="add-new-folder-button" onClick={()=>{addNewLesson();}}>إضافة</button>
                        <button className="add-new-folder-button" onClick={()=>{setShowNewLessonForm(false);setNewLesson({...newLesson,lessonName:"",url:"",imageUrl:""});setCapacityExceeded(false);}}>إلغاء</button>
                    </div>
                    </div>
                )}

                {showDeleteLessonForm &&(
                    <div className="overlay">
                    <div className="delete-lesson-folder-unit-form">
                        <div>
                            <h3>حذف الدرس</h3>
                            <p>هل انت متأكد أنك تريد حذف هذا الدرس؟</p>
                            <p>{lessonToEdit.name}</p>
                            </div>
                        <div className="lesson-delete-buttons">
                        <button className="lesson-delete-button" onClick={deleteLesson}>نعم</button>
                        <button onClick={()=>setShowDeleteLessonForm(false)}>لا</button>
                    </div>
                    </div>
                    </div>

                )}

                {showEditLessonFrom&&(
                    <div className="overlay">
                    <div className="add-new-lesson-form">
                        <h3>تعديل الدرس</h3>
                        <label>عنوان الدرس</label>
                        <input type="text" 
                        dir="rtl"
                        lang="ar"
                        value={lessonToEdit.lessonName}
                        onChange={(e)=>{setLessonToEdit({...lessonToEdit, lessonName: e.target.value})}}/>
                        {lessonToEdit.lessonName=="" && (<p className="warning">يرجى إدخال عنوان الدرس</p>)}
                        <button className="add-new-folder-button" onClick={updateLesson}>تعديل</button>
                        <button className="add-new-folder-button" onClick={()=>{setShowEditLessonFrom(false);setReload(!reload)}}>إلغاء</button>
                    </div>
                    </div>
                )}
                {showQRPopup&&(
                  <div className="overlay">
                    <div className="delete-lesson-folder-unit-form codes-div">
                      <h3 className="get-code-h3">الحصول علي اكواد</h3>
                      <h5 className="lesson-name" style={{textAlign:"right"}}>اسم المادة: {courseToEdit.name} </h5>
                      <div>
                      <input type="number" dir="rtl" value={codesToGenerate} onChange={(e)=>setCodesToGenerate(e.target.value)} />
                      <label className="number-of-codes-lable">عدد الاكواد</label>
                      </div>
                      <div style={{display:"flex",justifyContent:"space-around"}}>
                        <button style={{width:"fit-content",padding:"5px", fontSize:"medium"}} onClick={()=>{setShowQRPopup(false);setCodesToGenerate(0)}}>إغلاق</button>
                        <button style={{width:"fit-content",padding:"5px", fontSize:"medium"}} onClick={async ()=>{
                            const dataList = await getListOfCodes();
                            navigate(`/admin-home/lesson/qr-codes/${courseToEdit.courseId}`, {state:{lessonName: courseToEdit.name, dataList}})}}>{getCodes? "⏳": 'QR تحميل '}</button>
                            <button style={{width:"fit-content",padding:"5px", fontSize:"medium"}} onClick={downloadCodes}>{getCodes? "⏳": 'تحميل الأكواد'}</button>
                      </div>
                    </div>
                  </div>
                )}

            
                {showNotifyPopup && (
                    <div className="overlay">
                        <div className="add-new-course-form notify-popup" dir="rtl">
                            <h2>إرسال رسالة للطلاب</h2>

                            <label>عنوان الرسالة</label>
                            <input
                                type="text"
                                value={notifyTitle}
                                onChange={(e) => setNotifyTitle(e.target.value)}
                                placeholder="أدخل عنوان الرسالة"
                                maxLength={150}
                            />
                            <label>عناوين مقترحة</label>
                            <select value={notifyTitle} onChange={(e) => setNotifyTitle(e.target.value)}>
                                <option value="">اختر عنوانًا مقترحًا</option>
                                {suggestedNotificationTitles.map((title) => (
                                    <option key={title} value={title}>
                                        {title}
                                    </option>
                                ))}
                            </select>

                            <label>الصف الدراسي</label>
                            <select
                                value={notifyYear}
                                onChange={(e) => setNotifyYear(e.target.value)}
                            >
                                <option value="">اختر الصف الدراسي</option>
                                <option value= "all">الكل</option>

                                {yearsArabic.map((year) => (
                                    <option key={year} value={year}>
                                        {year}
                                    </option>
                                ))}
                            </select>

                            <label>نص الرسالة</label>
                            <textarea
                                value={notifyMessage}
                                onChange={(e) => setNotifyMessage(e.target.value)}
                                placeholder="اكتب رسالتك للطلاب..."
                                rows={5}
                                maxLength={5000}
                            />

                            <p className="notify-message-counter">
                                {notifyMessage.length}/5000
                            </p>

                            <div className="edit-admin-buttons">
                                <button
                                    className="edit-admin-button"
                                    disabled={sendingNotification}
                                    onClick={sendTeacherNotification}
                                >
                                    {sendingNotification ? "جارٍ الإرسال..." : "إرسال"}
                                </button>

                                <button
                                    disabled={sendingNotification}
                                    onClick={() => {
                                        setShowNotifyPopup(false);
                                    }}
                                >
                                    إلغاء
                                </button>
                            </div>
                        </div>
                    </div>
                )}

        </div>

        
        
    )

    

}